<div class="flex items-center gap-(--space-2) h-10">
  <ces-button-tertiary
    icon="chevron_left"
    [disabled]="!canNavigate()"
    [attr.aria-label]="'common.dateNavigation.previousPeriod' | transloco"
    (onClick)="navigatePrevious.emit()" />

  <label for="start-date" class="sr-only">{{ 'common.dateNavigation.startDateLabel' | transloco }}</label>
  <!-- UAT 27.07 #4 : pas de minDate/maxDate ; une date tapée hors plage doit atteindre le modèle
       et afficher le message ci-dessous, sinon le picker la rejette en silence. -->
  <p-datePicker
    inputId="start-date"
    [ngModel]="startDate()"
    (ngModelChange)="onStartDateChange($event)"
    (keydown.enter)="focusEndDate()"
    [dateFormat]="datePickerConfig.FORMAT"
    [showIcon]="true"
    iconDisplay="input"
    [placeholder]="datePickerConfig.PLACEHOLDER"
    [styleClass]="datePickerConfig.WIDTH"
    [attr.aria-label]="'common.dateNavigation.selectStartDate' | transloco" />

  <label for="end-date" class="sr-only">{{ 'common.dateNavigation.endDateLabel' | transloco }}</label>
  <p-datePicker
    inputId="end-date"
    [ngModel]="endDate()"
    (ngModelChange)="onEndDateChange($event)"
    (keydown.enter)="onEndDateEnter()"
    [dateFormat]="datePickerConfig.FORMAT"
    [showIcon]="true"
    iconDisplay="input"
    [placeholder]="datePickerConfig.PLACEHOLDER"
    [styleClass]="datePickerConfig.WIDTH"
    [disabled]="endDateDisabled()"
    [attr.aria-label]="'common.dateNavigation.selectEndDate' | transloco"
    [attr.aria-describedby]="dateRangeInvalid() ? 'date-constraint' : null" />

  @if (dateRangeInvalid()) {
    <small id="date-constraint" class="text-xs text-(color:--p-red-500) whitespace-nowrap" role="alert">
      {{ 'common.dateNavigation.dateConstraint' | transloco }}
    </small>
  }

  <ces-button-tertiary
    icon="chevron_right"
    [disabled]="!canNavigate()"
    [attr.aria-label]="'common.dateNavigation.nextPeriod' | transloco"
    (onClick)="navigateNext.emit()" />

  <ng-content />

  <ces-button-secondary
    icon="refresh"
    [label]="'common.buttons.refresh' | transloco"
    [disabled]="refreshDisabled() || dateRangeInvalid()"
    (onClick)="refresh.emit()" />
</div>
